module.exports = __webpack_public_path__ + "img/er.c979955.svg";